import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  saveAndBook: {
    color: "#32D583",
    border: "1px solid #32D583",
    backgroundColor: "transparent",
    "&:hover": {
      color: "#6CE9A6",
      borderColor: "#6CE9A6",
      backgroundColor: "transparent",
    },
    "&:active": {
      border: "none",
    },
    "&:disabled": {
      border: "none",
    },
  },
  buttons: {
    width: "100%",
  },
}));

export default styles;
